import { render, staticRenderFns } from "./FooterWx.vue?vue&type=template&id=ce11da5a&scoped=true&"
import script from "./FooterWx.vue?vue&type=script&lang=js&"
export * from "./FooterWx.vue?vue&type=script&lang=js&"
import style0 from "./FooterWx.vue?vue&type=style&index=0&id=ce11da5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce11da5a",
  null
  
)

export default component.exports